import type { ClassValue } from 'clsx';

import { NavbarUtility } from '@vs-shop/commerce-ui/navbarUtilities';
import { clsxm } from '@vs-shop/utils';

import { Url } from '../../../../route/router';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import { IconCartOutline } from '@vs-shop/ui/icons';

type Props = {
  className?: ClassValue;
  isNavigationBlocked: boolean;
  isNavigationUncertain: boolean;
};

/**
 * The basket affordance with nothing to count — the same affordance, without a
 * badge, rather than a different one.
 */
export default function NavbarCartFallback({
  className,
  isNavigationBlocked,
  isNavigationUncertain,
}: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const cartLabel = intl.formatMessage({
    id: 'navbar.cart.fallback.link',
    defaultMessage: 'Košík',
  });
  const statusId = 'navbar-cart-navigation-status';

  return (
    <>
      <NavbarUtility
        data-slot="navbar-cart-link"
        className={clsxm('lap:mr-8', className)}
        {...(isNavigationBlocked
          ? {}
          : { render: <a href={Url.cart} title={cartLabel} aria-label={cartLabel} /> })}
        disabled={isNavigationBlocked ? true : undefined}
        aria-label={cartLabel}
        {...(isNavigationBlocked || isNavigationUncertain ? { 'aria-describedby': statusId } : {})}
      >
        <IconCartOutline className="size-7 shrink-0 text-foreground lap:size-8" />
      </NavbarUtility>
      {(isNavigationBlocked || isNavigationUncertain) && (
        <span
          id={statusId}
          role="status"
          aria-live="polite"
          className="sr-only"
          data-slot="navbar-cart-navigation-status"
        >
          {isNavigationUncertain && !isNavigationBlocked
            ? intl.formatMessage({
                id: 'cartDrawer.pendingLine.unresolved',
                defaultMessage: 'Změnu košíku se nepodařilo ověřit',
              })
            : intl.formatMessage({
                id: 'cartDrawer.navigation.waiting',
                defaultMessage: 'Čekáme na potvrzení změny košíku.',
              })}
        </span>
      )}
    </>
  );
}
